export const locales = ["en", "es"] as const
export type Locale = typeof locales[number]
export function isLocale(value: unknown): value is Locale { return value === "en" || value === "es" }
export const languageTag = (locale: Locale) => locale === "es" ? "es-US" : "en-US"

export function routeLocale(pathname: string): Locale { return /^\/es(?:\/|$)/.test(pathname) ? "es" : "en" }
export function withoutLocale(pathname: string) { return pathname.replace(/^\/(?:en|es)(?=\/|$)/, "") || "/" }
export function isSharedResource(pathname: string) { return /^\/shop\/(?:orders|verify|checkout)(?:\/|$)/.test(pathname) || /^\/(?:admin|crm|my|api|document|group-pay|_next|media|wp-content)(?:\/|$)/.test(pathname) || /\.[a-z0-9]{2,6}(?:[?#]|$)/i.test(pathname) }
export function localeHref(href: string, locale: Locale): string {
  if (!href.startsWith("/") || href.startsWith("//") || isSharedResource(href)) return href
  const base = withoutLocale(href)
  return locale === "es" ? `/es${base.startsWith("/") ? base : `/${base}`}` : base
}
